import { Component, enableProdMode, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CitasService } from 'src/app/services/citas.service';
import { FormGroup, FormControl, Validators } from '../../../../node_modules/@angular/forms';
import { ResumenComponent } from '../resumen/resumen.component';
import { DatePipe } from '@angular/common';

enableProdMode();
@Component({
  providers: [DatePipe],
  selector: 'app-formulario',
  templateUrl: './formulario.component.html',
  styleUrls: ['./formulario.component.css']
})
export class FormularioComponent implements OnInit {


  formulario: FormGroup;
  minDate = new Date(new Date().setDate(new Date().getDate() + 1));

  ocupacionActual: any;
  mediosConocer: any;
  horas: any;
  entidades: any;
  myFilter: any;
  breakpoint: number;

  constructor(private router: Router, public dialog: MatDialog, private service: CitasService,
    private datePipe: DatePipe) {
    this.getCatalogos();
    this.formulario = new FormGroup({
      nombre: new FormControl('', [Validators.required, Validators.minLength(4)]),
      sexo: new FormControl('1'),
      empresa: new FormControl(''),
      estudios: new FormControl('1'),
      entidad: new FormControl('',[Validators.required]),
      ocupacionActual: new FormControl(''),
      email: new FormControl('', [Validators.required,
      Validators.pattern(/^[0-9a-zA-Z]+([0-9a-zA-Z]*[-._+])*[0-9a-zA-Z]+@[0-9a-zA-Z]+([-.][0-9a-zA-Z]+)*([0-9a-zA-Z]*[.])[a-zA-Z]{2,6}$/)
      ]),
      medios: new FormControl('', [Validators.required]),
      hora: new FormControl('', [Validators.required]),
      descripcion: new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(250)]),
      picker: new FormControl('', Validators.required),
      telefono: new FormControl('',[Validators.required,Validators.pattern(/^[0-9]{10,10}$/)]),
      terminos: new FormControl(false,Validators.pattern('true'))
  });

  this.myFilter = (date: Date) => {
    const day = new Date(date).getDay();
    const month = new Date(date).getMonth();
    const dateMonth = this.datePipe.transform(new Date(date), 'dd/MM');
    // Se descomentan los días de la semana par poder agendar citas
    //return dateMonth != '16/09' && day !== 0 && day !== 6 && day !== 5 && day !== 3 && day !== 2 && day !== 1;;
    return dateMonth != '16/09' && day !== 0 && day !== 6 ;
  }
  }

  ngOnInit(): void {
    this.windowSize(window.innerWidth);
  }

  onResize(event) {
    this.windowSize(event.target.innerWidth);
  }

  windowSize(size: any){
    if(size > 992){
      this.breakpoint = 6;
    }else if(size > 700){
      this.breakpoint = 3;
    }else if(size > 450){
      this.breakpoint = 2;
    }else{
      this.breakpoint = 1;
    }
  }
  

  async getCatalogos() {
    try {
      const get = await this.service.getCatalogo();
      this.horas = get.horarios;
      this.ocupacionActual =  get.ocupacion;
      this.mediosConocer = get.medios;
      this.entidades = get.entidades;
    } catch (error) {
      console.log(error);
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(ResumenComponent, {
      data: {
        nombre: this.formulario.controls.nombre.value,
        sexo: this.formulario.controls.sexo.value,
        email: this.formulario.controls.email.value,
        empresa: this.formulario.controls.empresa.value,
        entidad: this.formulario.controls.entidad.value,
        ocupacionActual: this.formulario.controls.ocupacionActual.value,
        hora: this.formulario.controls.hora.value,
        descripcion: this.formulario.controls.descripcion.value,
        picker: this.formulario.controls.picker.value,
        formulario: this.formulario,
        medios: this.formulario.controls.medios.value,
        mensaje: '',
        telefono: this.formulario.controls.telefono.value
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != "0") {
        const dialog = this.dialog.open(EstatusDialog, {
          data: {
            mensaje: result
          }
        });
        dialog.afterClosed().subscribe(result => {
          window.location.reload();
        })
      }
    });
  }

  onclick(){
    let dialog=this.dialog.open(TerminosCondicoines);

    dialog.afterClosed().subscribe(result=>{
     //this.formulario.controls.terminos.value=result;
      this.formulario.patchValue({
        terminos: result
      })
    })
  }

 async onChange(){
  try {
    const get = await this.service.getHorarios(this.formulario.controls.picker.value);
    this.horas = get;
    if(this.horas.length === 0){
      const dialogRef = this.dialog.open(EstatusDialog, {
        data: {
          mensaje: `No Existen Horarios Disponibles para esta Fecha`
        }
      });
    }
  } catch (error) {
    console.log(error);
  }
  }
}

@Component({
  selector: 'estatusDialog',
  templateUrl: 'estatusCitaDialog.html',
})
export class EstatusDialog {

  constructor(
    public dialogRef: MatDialogRef<EstatusDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any, private service: CitasService) { 
       dialogRef.disableClose = true;
      
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

}



@Component({
  selector: 'terminosCondicoines',
  templateUrl: 'terminosCondicoines.html',
})
export class TerminosCondicoines {

  constructor(
    public dialogRef: MatDialogRef<TerminosCondicoines>,
    @Inject(MAT_DIALOG_DATA) public data: any) {  dialogRef.disableClose = true;}

  onNoClick(): void {
    this.dialogRef.close(true);
  }

  cancelar(): void{
    this.dialogRef.close(false);
  }

}
